// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-forgot-password__snackbar{height:50%}.dashboard-forgot-password__snackbar .v-icon{margin-right:.5rem}.dashboard-forgot-password__snackbar .v-snack__content{justify-content:start}", ""]);
// Exports
module.exports = exports;
